import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from "@angular/forms";
import { AWBService } from "src/app/services/operations/awb.service";
import { OperatorFunction, Observable, debounceTime, distinctUntilChanged, map, } from "rxjs";
import { EditDeleteActionsRenderer } from "../ag-grid/cell-renderers/edit-delete.component";
import { GridApi, GridOptions, GridReadyEvent, ColumnApi } from "ag-grid-community";
import { AgGridAngular } from "ag-grid-angular";
import { MiscService } from "src/app/services/misc/misc.service";
import { AppCoreService } from "src/app/services/app-core.service";

@Component({
  selector: 'app-performa',
  templateUrl: './performadetails.component.html',
  styleUrls: ['./performadetails.component.scss'],
})

export class PerformaComponent implements OnInit, OnChanges {
  @ViewChild('agGrid') agGrid: AgGridAngular;
  @Input() piecesId: any;
  @Input() performaData: any[] = [];
  @Output() performaDataList = new EventEmitter<any[]>();
  @Output() totalWeight = new EventEmitter<any[]>();

  piecesWeight: any[] = [];
  data: any;
  isFormSubmitted: boolean = false;
  performaDetailsForm: FormGroup;
  performaDescriptionList: any;
  isPerformaDetailsFormSubmit = false;
  isPerfromDetailsEdit = false;
  performaUnitOptions: any[] = [{ code: "BOX", name: "Boxes" }, { code: "BOTTLE", name: "BOTTLE" }, { code: "KGS", name: "Kilogram" }, { code: "PCS", name: "Pieces" }, { code: "PKT", name: "Packet" }, { code: "SET", name: "Set" }];
  PerformaDetailsId: any;
  selectedPerformaDetails: any;
  useEnterKey: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['performaData']) {
      this.calculateTotatlWeight();
    }
  }
  //Grid
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,
  };

  columnDefs = [
    { headerName: 'Description', field: 'description', filter: true, width: 120 },
    { headerName: 'HSN Code', field: 'hsncode', width: 80 },
    { headerName: 'Weight', field: 'weight', width: 80 },
    { headerName: 'Unit', field: 'unitvalue', width: 80 },
    { headerName: 'Rate', field: 'rate', width: 80 },
    { headerName: 'Quantity', field: 'quantity', width: 80 },
    { headerName: 'Amount', field: 'amount', width: 80 },
    {
      headerName: 'Actions',
      field: 'id',
      cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      width: 80,
    },
  ];

  gridOptions: GridOptions = {
    columnDefs: this.columnDefs,
    pagination: true,
    paginationPageSize: 10
  }

  // performaData = [];

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    // console.log("ready",params);
  }

  editAction(cell: any) {
    try {
      if (cell) {
        this.getPerforma(cell);
      }

    } catch (e) {
      console.error(e);
    }

  }

  deleteAction(cell: any) {
    if (cell) {
      this.performaData.splice(cell, 1);
      const api = this.agGrid.api
      api.setRowData(this.performaData)
    }
  }

  constructor(
    private rootFormGroup: FormGroupDirective,
    private formBuilder: FormBuilder,
    private awbService: AWBService,
    private miscService: MiscService,
    private appCoreService:AppCoreService
  ) {
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.performaDetailsForm = this.formBuilder.group({
      txtPieces: [null],
      txtDescription: [null, Validators.compose([Validators.maxLength(40), Validators.required])],
      txtHSNCode: [null, Validators.compose([Validators.maxLength(10)])],
      txtQuantity: [null, Validators.compose([Validators.pattern(/^\d{1,3}$/), Validators.required])],
      txtWeight: [null, Validators.compose([Validators.pattern(/^[0-9]{0,10}(\.[0-9]{0,2})?$/)])],
      ddlUnit: ['KGS'],
      txtRate: [null, Validators.compose([Validators.required, Validators.pattern(/^[0-9]{0,10}(\.[0-9]{0,2})?$/)])],
      txtAmount: [null]
    });
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.bindPerformaDescription();
    this.performaDetailsForm.get('txtAmount').disable();
  }

  bindPerformaDescription() {
    try {
      this.miscService.GetAllGoods().subscribe((res) => {
        if (res && res.success) {
          this.performaDescriptionList = res.data;
        }
      })
    }
    catch (e) {
      console.error(e);
    }
  }

  calculateTotatlWeight() {
    this.piecesWeight = [];
    for (const data of this.performaData) {
      const piecesId = data.piecesid;
      const weight = data?.weight ? parseFloat(data?.weight) : 0;
      if (!this.piecesWeight[piecesId]) {
        this.piecesWeight[piecesId] = 0;
      }
      this.piecesWeight[piecesId] += weight;
    }
    this.totalWeight.emit(this.piecesWeight)
  }

  getUnitValue(data?: any): string {
    return this.performaUnitOptions.find(item => item.code === data)?.name || this.performaUnitOptions.find(item => item.name === data)?.name;
  }


  getPerforma(data) {
    const performa = data;
    const performadesc = { name: performa.description };
    const unitcode = this.performaUnitOptions.find((item) => item.name == performa.unit)?.code;

    this.performaDetailsForm.get('txtPieces')?.setValue(performa.pieces);
    this.performaDetailsForm.get('ddlBoxNo')?.setValue(performa.piecesid);
    this.performaDetailsForm.get('txtDescription')?.setValue(performadesc);
    this.performaDetailsForm.get('txtHSNCode')?.setValue(performa.hsncode);
    this.performaDetailsForm.get('txtQuantity')?.setValue(performa.quantity);
    this.performaDetailsForm.get('txtWeight')?.setValue(performa.weight);
    this.performaDetailsForm.get('ddlUnit')?.setValue(unitcode ? unitcode : performa.unit);
    this.performaDetailsForm.get('txtRate')?.setValue(performa.rate);
    this.performaDetailsForm.get('txtAmount')?.setValue(performa.amount)
    this.isPerfromDetailsEdit = true;
    this.PerformaDetailsId = data?.id;
  }

  addPerforma() {
    const description = this.performaDetailsForm.get('txtDescription')?.value;
    const quantity = this.performaDetailsForm.get('txtQuantity')?.value;
    const rate = this.performaDetailsForm.get('txtRate')?.value;
    if (!description || !quantity || !rate) {
      return;
    }
    const uniqueId = this.performaData.length + 1;
    const data = {
      id: uniqueId,
      piecesid: this.piecesId,
      pieces: this.performaDetailsForm.get('txtPieces')?.value,
      description: description?.name,
      hsncode: description?.hsncode,
      quantity: this.performaDetailsForm.get('txtQuantity')?.value,
      weight: this.performaDetailsForm.get('txtWeight')?.value,
      unit: this.performaDetailsForm.get('ddlUnit')?.value,
      rate: this.performaDetailsForm.get('txtRate')?.value,
      amount: this.performaDetailsForm.get('txtAmount')?.value
    }
    this.performaData = [...this.performaData, data];
    this.performaDataList.emit(this.performaData);
    this.resetPerforma();
  }

  calculatePerformAmount() {
    const quantity = this.performaDetailsForm.get('txtQuantity')?.value;
    const rate = this.performaDetailsForm.get('txtRate')?.value;
    const amount = quantity * rate;
    this.performaDetailsForm.get('txtAmount')?.setValue(amount);
  }

  updatePerforma() {
    const description = this.performaDetailsForm.get('txtDescription')?.value;
    const quantity = this.performaDetailsForm.get('txtQuantity')?.value;
    const rate = this.performaDetailsForm.get('txtRate')?.value;
    if (!description || !quantity || !rate) {
      return;
    }
    const data = {
      pieces: this.performaDetailsForm.get('txtPieces')?.value,
      piecesid: this.piecesId,
      description: description?.name,
      hsncode: description?.hsncode || this.performaDetailsForm.get('txtHSNCode')?.value,
      quantity: quantity,
      weight: this.performaDetailsForm.get('txtWeight')?.value,
      unit: this.performaDetailsForm.get('ddlUnit')?.value,
      rate: rate,
      amount: this.performaDetailsForm.get('txtAmount')?.value
    }
    this.performaData = this.performaData.map(item => {
      if (item.id === this.PerformaDetailsId) {
        return { id: this.PerformaDetailsId, ...data }
      }
      else {
        return item;
      }
    })
    this.performaDataList.emit(this.performaData)
    this.resetPerforma();
  }

  deletePerforma(index: any) {
    this.performaData.splice(index, 1);
    this.calculateTotatlWeight();
  }

  resetPerforma() {
    this.isPerformaDetailsFormSubmit = false;
    this.performaDetailsForm.reset();
    this.performaDetailsForm.get('txtAmount').disable();
    this.performaDetailsForm.get('ddlUnit').setValue('KGS');
  }

  searchperforma: OperatorFunction<string, readonly { name; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.performaDescriptionList?.filter((v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  selectedItemEventPerformaDescription(event: any) {
    try {
      if (event) {
        const item = event.item;
        this.performaDetailsForm.patchValue({
          txtHSNCode: item.hsncode
        })
      }

    }
    catch (e) {
      console.error(e);
    }
  }

  formatter = (x: { name: string }) => x.name;

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === '.') {
      event.preventDefault();
    }
  }
}